export const formatNumber = (
  x?: number,
  options?: Intl.NumberFormatOptions,
): string => {
  return x?.toLocaleString(undefined, options) ?? '';
};
